import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
    Assessment,
    ArrowRightAlt,
    VerifiedUser,
    AccountBalanceWallet,
    PieChart,
    Folder,
    LocationSearching
} from '@material-ui/icons';
import { ItemIcon } from '../Home/Sections/OurOffer/OurOffer.styles';
import { Image, DotContainer, Dot } from '../Home/Sections/Steps/Steps.styles';
import { Verification } from '../components/dialogs/Verification';
import { MarginWrapper } from '../Dashboard/Dashboard.styles';
import { useAuth } from '../context/auth';
import { SectionName, SectionTitle } from "../Home/Home.styles";
import { HeaderWrapper, HeaderContainer } from '../CampaignDetails/CampaignDetails.styles';
import Img from '../assets/benefits_image.jpg';
import {
    StyledContainer,
    BackButton,
    Description,
    Item,
    GridWrapper,
    SmallItem,
    GridContainer,
    Wrapper,
    SectionWrapper,
    OfferWrapper,
    OffersWrapper,
    CostWrapper,
    Divider,
    StyledButton,
    StyledImageWrapper,
    DisabledButton
} from './Benefits.styles';

export function Benefits() {
    const location = useLocation();
    const history = useHistory();
    const { authToken, user, refreshDovePoints, wallet } = useAuth();
    const [verificationOpen, setVerificationOpen] = useState(false);
    const offers = [
        {
            title: 'Target your audience based on specialty & geolocation',
            description: 'You want to specifically reach people in the Midwest with heart devices; you want to conduct a breast cancer awareness campaign for New Yorkers? DoveMed Ads can help you do so!',
            icon: <LocationSearching />
        },
        {
            title: 'Wide range of topics - over 200 specialties',
            description: 'From Adult Reconstructive Orthopaedic Surgery to Clinical Molecular Genetics; from Gynecologic Oncology to Pulmonary Disease and Critical Care Medicine, DoveMed hosts content that relate to 228 medical specialties.',
            icon: <Folder />
        },
        {
            title: 'Opinion poll of your target audience',
            description: 'Want to raise an awareness on COVID vaccine? Want to conduct a survey on addiction in teens? Are you interested in promoting a new diabetes medication? DoveMed Ads lets you do so!',
            icon: <Assessment />
        },
        {
            title: 'World Class content approved by doctors',
            description: 'DoveMed offers highest quality and reliable medical information, to help consumers make better decisions regarding their overall health and well-being. All content is peer-reviewed by healthcare professionals to ensure credibility.',
            icon: <VerifiedUser />
        },
        {
            title: 'Monitor your ad’s performance in real-time',
            description: 'Our easy to use personalized dashboard, let’s you understand how your ad campaigns are performing in real-time. You can see impressions and engagements accumulate in real-time on DoveMed Ads.',
            icon: <PieChart />
        },
        {
            title: 'Campaign that fits your budget',
            description: 'Whether it is a small campaign that runs for a few days within a limited budget, or a large campaign spanning several geographical regions and running for many months, DoveMed offers you the flexibility to do so.',
            icon: <AccountBalanceWallet />
        }
    ];
    const whoCanAdvertise = ['Healthcare', 'Education & Research', 'Niche Brands', 'Finance & Insurance', 'Travel & Leisure', 'and many more...'];
    const whoCanBenefit = ['Hospitals & Clinics', 'Pharmaceutical Companies', 'Non-For-Profits', 'Healthcare Providers & Physicians', 'Conference Organizers', 'and many more…'];
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    let tab = ["."];
    const Dots = () => {
        for (var i = 0; i < 24; i++) {
            tab.push(".");
        }
    }
    Dots();
    const getFreePoints = () => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/payments/clients/get-free-points/`, {headers: { DTOKEN: `${authToken}`}}).then(res => {
            refreshDovePoints();
            redirect(`${process.env.REACT_APP_INTERNAL_URL}create-campaign/`);
        })
    }
    const redirect = (path: string) => {
        history.push(path);
    }
    return (
        <>
            <MarginWrapper verified={user ? user.verifiedAccount : false}>
                <HeaderWrapper>
                    <HeaderContainer>
                        <h1>Benefits of running ads on Article Pages</h1>
                    </HeaderContainer>
                </HeaderWrapper>
            </MarginWrapper>
            <StyledContainer>
                <BackButton startIcon={<ArrowRightAlt/>} onClick={() => history.goBack()}>
                    Back
                </BackButton>
                <SectionWrapper>
                    <SectionName>What are Article Pages?</SectionName>
                    <SectionTitle>World Class content approved by doctors</SectionTitle>
                    <GridContainer>
                        <div>
                            <Description>
                                DoveMed offers highest quality and reliable medical information, to help consumers make better decisions regarding their overall health and well-being. All content is peer-reviewed by healthcare professionals to ensure credibility. DoveMed is trusted by physicians, researchers, and university professors to provide impartial medical content to people all around the world. By developing innovative content, we strive to continue to build a community that is geared at growing medical literacy and wellness across the globe.
                            </Description>
                            <Wrapper>
                                <SmallItem>
                                    <h3>38,000 +</h3>
                                    <p>Articles</p>
                                </SmallItem>
                                <SmallItem>
                                    <h3>228 +</h3>
                                    <p>Specialties</p>
                                </SmallItem>
                            </Wrapper>
                        </div>
                        <div>
                            <StyledImageWrapper>
                                <Image src={Img} alt='Image' />
                                <DotContainer>
                                    {tab.length > 0 && tab.map((e, index) => (
                                        <Dot key={index}></Dot>
                                    ))}
                                </DotContainer>
                            </StyledImageWrapper>
                        </div>
                    </GridContainer>
                </SectionWrapper>
                <SectionWrapper>
                    <SectionName>Why Advertise on Article Pages?</SectionName>
                    <SectionTitle>DoveMed offers a wide range of benefits</SectionTitle>
                    <OffersWrapper>
                        {offers.map((offer, index) => (
                            <OfferWrapper key={index}>
                                <ItemIcon backgroundColor="#44d7b626" iconColor="#44D7B6">
                                    {offer.icon}
                                </ItemIcon>
                                <div>
                                    <h3>{offer.title}</h3>
                                    <p>{offer.description}</p>
                                </div>
                            </OfferWrapper>
                        ))}
                    </OffersWrapper>
                </SectionWrapper>
                <SectionWrapper>
                    <SectionName>Categories of Advertisers</SectionName>
                    <SectionTitle>No matter the scale, we got you covered</SectionTitle>
                    <Description>
                        Are you in the healthcare space? Is your domain medical insurance? Are you a public healthcare agency seeking to advertise a campaign? We got you covered!<br />
                        DoveMed hosts content based on various areas of healthcare. We have over 30,000 article pages that relates to 228 medical specialties. Topics of interest include diseases and conditions, laboratory procedures, radiology procedures, surgical procedures, first aid, and current medical news.
                    </Description>
                    <GridWrapper>
                        {whoCanAdvertise.map((who, index) => (
                            <Item key={index}>
                                <h3>{who}</h3>
                            </Item>
                        ))}
                    </GridWrapper>
                </SectionWrapper>
                <SectionWrapper>
                    <SectionName>Who Can benefit?</SectionName>
                    <SectionTitle>Target audience of your campaigns</SectionTitle>
                    <Description>
                        DoveMed Ads can help benefit hospitals and healthcare systems, medical clinics, non-for-profit organizations, pharmaceutical companies, medical devices and equipment manufacturers, medical conference organizers, and several other organizations, to help reach their target audience with their custom-built campaigns.
                    </Description>
                    <GridWrapper>
                        {whoCanBenefit.map((who, index) => (
                            <Item key={index}>
                                <h3>{who}</h3>
                            </Item>
                        ))}
                    </GridWrapper>
                </SectionWrapper>
                <SectionWrapper>
                    <SectionName>How much does it cost?</SectionName>
                    <SectionTitle>Highest value for your marketing dollar in the industry</SectionTitle>
                    <Description>
                        Unlike what other companies offer, our DoveMed prorietary ad management system gives you better returns for your money.<br />
                        Our campaign manager guarantees the number of views/impressions at a fixed rate, so no more guessing on your ad performance for your budget.<br />
                        Our DovePoints system helps you track your performance in real time. You have total control on your budget and no surprises on your credit card statements.
                    </Description>
                    <CostWrapper>
                        <div>
                            <h1>2 DovePoints</h1>
                            <p>per impression</p>
                        </div>
                        <Divider>
                            <span>or</span>
                            <div></div>
                        </Divider>
                        <div>
                            <h1>10 DovePoints</h1>
                            <p>per interaction</p>
                        </div>
                    </CostWrapper>
                    {authToken 
                        ? 
                        <>
                            {(user && user.verifiedAccount && wallet)
                                ? wallet.hasWallet
                                    ? <StyledButton to={`${process.env.REACT_APP_INTERNAL_URL}create-campaign`}>Start now</StyledButton>
                                    : <DisabledButton onClick={getFreePoints}>Start now</DisabledButton>  
                                : <DisabledButton onClick={() => setVerificationOpen(true)}>Start now</DisabledButton>  
                            }
                        </>
                        :
                            <StyledButton to={{
                                pathname: location.pathname,
                                state: { openLogin: true }
                            }}>Start now</StyledButton>
                    }          
                </SectionWrapper>
            </StyledContainer>
            <Verification open={verificationOpen} setOpen={setVerificationOpen} />
        </>
    )
}
